import { formatCPF } from "@brazilian-utils/brazilian-utils";
import { Box, HStack } from "@chakra-ui/react";
import ItemDetails from "./ItemDetails";
import CardDefault from "ui/components/Cards/CardDefault";
import fotoExemplo from "assets/images/placeholder-person.png";
import { Flex, Tag, TagLabel } from "@chakra-ui/react";
import {
  SolicitacaoCadastroDetails,
  StatusSolicitacaoCadastroEnum,
} from "core/features/SolicitacaoCadastro/typings";
import colors from "core/resources/theme/colors";
import { formatPhone } from "infra/helpers/number";

function PessoaInfo({ data }: { data: SolicitacaoCadastroDetails }) {
  return (
    <CardDefault borderRadius={16} mb={7}>
      <HStack>
        <Box>
          <img
            src={data.pessoa.imagemUrl || fotoExemplo}
            alt="Foto"
            width="170"
            style={{ borderRadius: 12 }}
          />
        </Box>

        <Flex flexDir="column" flex={1}>
          <Flex flex={1}>
            <Flex flex={1}>{data.pessoa.nome}</Flex>
            <Flex
              alignItems="center"
              // mb="14px"
              // marginTop="-40px"
              gridGap="14px"
              justifyContent="space-between"
            >
              <Tag
                bg={getTagBgColor(data.statusId)}
                color="#FFFFFF"
                rounded="full"
              >
                <TagLabel>{data.statusNome}</TagLabel>
              </Tag>
            </Flex>
          </Flex>

          <Flex display="flex">
            <ItemDetails label="Unidade" value={data.unidade} />
            <ItemDetails label="CPF" value={formatCPF(data.pessoa?.cpf)} />
          </Flex>
          <Flex alignItems="center">
            <ItemDetails
              label="Telefone"
              value={formatPhone(data.pessoa.celular)}
            />
            <ItemDetails label="E-mail" value={data.pessoa.email} />
          </Flex>
        </Flex>
      </HStack>
    </CardDefault>
  );
}

const getTagBgColor = (status: StatusSolicitacaoCadastroEnum) => {
  switch (status) {
    case StatusSolicitacaoCadastroEnum.Aprovado:
      return colors.green;
    case StatusSolicitacaoCadastroEnum.Rejeitado:
      return colors.red;
    case StatusSolicitacaoCadastroEnum.EmAnalise:
      return colors.orange;
    default:
      return colors.blue;
  }
};

export default PessoaInfo;
